export default __webpack_public_path__ + "static/media/chevron-arrow.829b12e3.svg";